import pako from "pako";

/**
 * UtilBrowser 类用于解析和获取浏览器相关的信息
 */
export default class UtilGzip {
    // 静态属性定义
    static tag: string = `[UtilGzip]`;
    /**
     * Gzip压缩
     * @param data 要压缩的字符串
     * @returns 压缩后的Uint8Array
     */
    static compress(data: string): Uint8Array {
        try {
            return pako.gzip(data);
        } catch (error) {
            console.error(this.tag, 'Gzip compression failed:', error);
            throw error;
        }
    }

    /**
     * Gzip解压
     * @param compressedData 压缩后的Uint8Array
     * @returns 解压后的字符串
     */
    static decompress(compressedData: Uint8Array): string {
        try {
            return pako.ungzip(compressedData, { to: 'string' });
        } catch (error) {
            console.error(this.tag,'Gzip decompression failed:', error);
            throw error;
        }
    }

}


